// extracted by mini-css-extract-plugin
export var cardImage = "action-card-module--card-image--d430d";
export var cardLink = "action-card-module--card-link--70870";
export var cardTitle = "action-card-module--card-title--26b74";
export var cardWrapper = "action-card-module--card-wrapper--646ca";